<block-ui [delayStart]="100" [delayStop]="200">
  <section class="main-body">
    <p [hidden]="true"> Version: {{version}}</p>
    <app-header *ngIf="showHeader"></app-header>

    <div class="modal fade" id="sessiontimeout" [ngClass]="{'show' : IsSessionExpired, 'hide':!(IsSessionExpired)}"
         [ngStyle]="{'display': IsSessionExpired ? 'block' : 'none'}" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title w-100 d-block">
              Session Timeout !
              <a (click)="closeTimeoutPopup();" class="fs-12 text-underline float-right pt-1 text-white" data-dismiss="modal"><i class="fas fa-times"></i></a>
            </h5>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12">
                  <p class="fs-14 text-center">
                    Your session has expired due to inactivity. Please click here to <a href="javascript:void(0)"
                                                                                        (click)="openLoginForm()">Login</a>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <section class="pageContentMain">

      <router-outlet></router-outlet>
      <app-footer *ngIf="showFooter"></app-footer>

      <div *ngIf="showHeader && !regLogin" class="modal self-hcp-backdrop fade" [ngClass]="{'show' : !authService.isUserLoggedIn() && (!utilityService.isProfileSelected() || utilityService.isProfileSelection) }" id="autoModal" data-backdrop="true" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
           [ngStyle]="{'display': !authService.isUserLoggedIn() && (!utilityService.isProfileSelected() || utilityService.isProfileSelection) ? 'block' : 'none'}">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div id="lgScreen" class="modal-header text-center">
              <h5 class="modal-title" id="exampleModalLabel">Welcome to {{utilityService.getPortalName()}}'s Medical Information Portal</h5>
            </div>
            <div id="smScreen" class="modal-header text-center">
              <h5 class="modal-title" id="exampleModalLabel">Welcome to {{utilityService.getPortalName()}}'s</h5>
              <h5 class="modal-title" id="exampleModalLabel">Medical Information Portal</h5>
            </div>
            <div class="modal-body popup-scroll">
              <p class="fs-13 text-center"> This site is an online medical resource intended to provide scientifically accurate, evidence-based, and balanced medical information on Mallinckrodt products. </p>
              <p class="fs-13 text-center pt-2"> The information provided on this site and by Medical Information are not intended to provide medical advice or guidelines, but rather to empower healthcare providers, patients, and caregivers to make informed decisions. Healthcare providers should use their own medical judgement when making individual treatment decisions. Patients are urged to seek medical guidance from their healthcare practitioners. </p>
              <p class="fs-13 text-center pt-2"> In order to provide you with relevant and meaningful content we need to know more about you. Please select the category that best describes you. </p>
              <ng-container *ngFor="let userprofile of portalProfiles">
                <button type="button" class="btn btn-block btn-primary mt-3 fs-14" data-dismiss="modal" [id]="'btn-' + userprofile.PROFILE_CODE" (click)="NavigatePortalUser(userprofile, true);">
                  I am a {{userprofile.NAME}}</button>
              </ng-container>
              <p class="fs-13 pt-2">
                <!-- #:~:text=You%20may%20not%2C%20for%20any,All%20rights%20reserved -->
                Please review our <a href="https://www.mallinckrodt.com/terms-of-use/" target="_blank">Terms of Use</a> and 
                <a href="https://www.mallinckrodt.com/privacy-policy" target="_blank">Privacy Policy</a> before continuing into this site.
                <!-- #CookiesOtherWebDevices -->
              </p>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="utilityService.IsNotHcpAction" class="modal self-hcp-backdrop fade show z-index-3" id="nonhcpredirection2"
           [ngStyle]="{'display': utilityService.IsNotHcpAction ? 'block' : 'none'}"
           data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title w-100 d-block">
                Welcome to Patient/Caregiver Page
              </h5>
            </div>
            <div class="modal-body pt-0">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12 text-center mt-3 px-0">
                    <h3 class="fs-14">
                      You are about to leave {{utilityService.getPortalName()}} Medical Information Portal
                    </h3>
                    <p class="fs-14 pt-3">Please <a href="https://www.scimaxglobal.com/">Click Here </a> to Continue to page 1</p>
                    <p class="fs-14 pt-3">Please <a href="https://www.techsolcorp.com/">Click Here </a> to Continue to page 2</p>
                  </div>
                  <button type="button" class="btn btn-primary btn-block text-center mt-3 fs-14" data-dismiss="modal" (click)="onNonHCPClose();">Close</button>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <!-- <div *ngIf="showHeader" class="privacyPrompt pt-4" [ngStyle]="{'display':cookieToogle ? 'block' : 'none'}">
        <div class="row">
          <div class="col-md-9 col-sm-8">
            <p>
              {{utilityService.getPortalName()}} uses cookies to improve and analyze site functionality. Some aspects of the site may not function properly without cookies 
              enabled. To learn more about how we use cookies and how you can change your cookies settings, please read our <a href="https://www.mallinckrodt.com/privacy-policy#CookiesOtherWebDevices" target="_blank"> Privacy Policy. </a> By continuing to browse the site, you are agreeing to accept our use of cookies.
            </p>
          </div>
          <div class="col-md-3 col-sm-4">
            <div class="text-right mbl-100 cookieSettings">
              <a href="javascript:void(0);" (click)="allowCookies()">Accept</a>
              <a href="javascript:void(0)" (click)="closeCookies()">Reject</a>
            </div>
          </div>
        </div>
      </div> -->

    </section>

    <app-toast-message></app-toast-message>
  </section>
</block-ui>
